import gql from 'graphql-tag';

export const VIEW_HEARTBEAT_REGISTRY_CONFIG_BY_REGISTRY = gql`
    query heartbeatRegistryConfig($projectId: Int64!, $registryId: Int64!) {
        heartbeatRegistryConfig(projectId: $projectId, registryId: $registryId) {
            project_id
            registry_id
            timeout
        }
    }
`;

export const UPDATE_HEARTBEAT_REGISTRY_CONFIG = gql`
    mutation updateHeartbeatRegistryConfig($project_id: Int64!, $registry_id: Int64!, $input: HeartbeatRegistryConfigInput!) {
        updateHeartbeatRegistryConfig(projectId: $project_id, registryId: $registry_id, input: $input) {
            project_id
            registry_id
            timeout
        }
    }
`;